<template>

    <div>
        <fin-notice-info></fin-notice-info>
<!--        <van-nav-bar :title="title" ></van-nav-bar>-->
        <van-tabs v-model="active" sticky>
            <van-tab  title="主账单">
                <my-finance></my-finance>
            </van-tab>
            <van-tab  title="储值账单">
                <trance-finance-detail></trance-finance-detail>
            </van-tab>
        </van-tabs>
    </div>

</template>

<script>

    import MyFinance from "./finance/MyFinance";
    import TranceFinanceDetail from "./finance/TranceFinanceDetail";

    import FinNoticeInfo from "./other/FinNoticeInfo";
    export default {
        name: "FinancePage",
        components: {
            MyFinance,
            FinNoticeInfo,
            TranceFinanceDetail
        },
        data(){
            return {
                //title:'记账',
                active:0
            }
        }
    }
</script>

<style scoped>

</style>
